import React from 'react';

const ExportSection = ({ lang }) => {
  const isRtl = lang === 'ar';

  const scrollToContact = (e) => {
    e.preventDefault();
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      window.scrollTo({ top: contactSection.offsetTop - 80, behavior: 'smooth' });
    }
  };

  const ships = [
    { brand: "Baseel", delay: "0s", speed: "18s", size: "1.1", bottom: "75px", z: "25" },
    { brand: "C-Plus", delay: "4s", speed: "14s", size: "0.9", bottom: "95px", z: "22" },
    { brand: "Mival", delay: "8s", speed: "20s", size: "0.7", bottom: "115px", z: "18" },
    { brand: "XClor", delay: "12s", speed: "16s", size: "1.0", bottom: "95px", z: "24" }
  ];

  return (
    <section id="export" className="export-section">
      <div className="container-large">
        <div className="export-main-grid">
          
          {/* محتوى النصوص - تم تحسين التنسيق هنا */}
          <div className="export-text-content entrance-fade-up">
            <div className="export-header-meta">
               <span className="export-badge">{isRtl ? 'العمليات اللوجستية والشحن' : 'LOGISTICS & SHIPPING'}</span>
               <div className="live-indicator">
                 <span className="dot"></span> {isRtl ? 'بث حي للعمليات' : 'Live Operations'}
               </div>
            </div>
            
            <h2 className="export-title">
              {isRtl ? 'شراكات تمتد عبر المحيطات' : 'Partnerships Across Oceans'}
            </h2>
            
            <p className="export-desc">
              {isRtl 
                ? 'نحن نضمن وصول منتجاتنا إلى عملائنا الدوليين في أكثر من 15 وجهة عالمية بفضل نظام لوجستي متطور يعمل على مدار الساعة دون توقف.'
                : 'We ensure our products reach international clients in 15+ global destinations through an advanced logistical system operating 24/7.'}
            </p>
            
            <div className="export-features-grid">
               <div className="f-item">
                  <span className="f-number">15+</span>
                  <span className="f-label">{isRtl ? 'وجهة عالمية' : 'Global Destinations'}</span>
               </div>
               <div className="f-item">
                  <span className="f-number">24/7</span>
                  <span className="f-label">{isRtl ? 'تتبع ذكي' : 'Smart Tracking'}</span>
               </div>
            </div>
          </div>

          {/* المشهد البصري - كما هو في كودك المفضل */}
          <div className="visual-container entrance-fade-right">
            <div className="visual-port-scene night-mode">
              <div className="sky-bg">
                <div className="moon"></div>
                <div className="stars"></div>
              </div>

              <div className="lighthouse">
                <div className="lighthouse-top"><div className="light-beam"></div></div>
                <div className="lighthouse-body"></div>
              </div>

              {ships.map((ship, idx) => (
                <div 
                  key={idx} 
                  className="ship-path" 
                  style={{ 
                    animationDuration: ship.speed, 
                    animationDelay: ship.delay,
                    bottom: ship.bottom,
                    zIndex: ship.z,
                    transform: `scale(${ship.size})`
                  }}
                >
                  <div className="vessel night-vessel">
                     <div className="cargo-box-neon">{ship.brand}</div>
                     <div className="vessel-body">
                        <div className="cabin-windows"></div>
                     </div>
                     <div className="vessel-reflection"></div>
                  </div>
                </div>
              ))}

              <div className="ocean-base">
                <div className="moon-reflection"></div>
                <div className="deep-blue-night"></div>
              </div>
            </div>
          </div>
        </div>

        {/* كرت التواصل السفلي */}
        <div className="export-footer-cta entrance-fade-up" style={{ animationDelay: '0.6s' }}>
           <div className="cta-inner">
              <div className="cta-text">
                <h3>{isRtl ? 'هل تريد أن تصبح موزعاً معتمداً؟' : 'Want to become a distributor?'}</h3>
                <p>{isRtl ? 'انضم إلى شبكة موردينا حول العالم' : 'Join our global supplier network'}</p>
              </div>
              <a href="#contact" onClick={scrollToContact} className="btn-export-contact">
                {isRtl ? 'تواصل معنا الآن' : 'Contact Us Now'}
              </a>
           </div>
        </div>
      </div>

      <style>{`
        /* أنيميشن الدخول */
        @keyframes fadeUp { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes fadeRight { from { opacity: 0; transform: translateX(40px); } to { opacity: 1; transform: translateX(0); } }
        .entrance-fade-up { animation: fadeUp 0.8s ease-out forwards; }
        .entrance-fade-right { animation: fadeRight 1s ease-out forwards; }

        .export-section { padding: 100px 5%; background: #ffffff; direction: ${isRtl ? 'rtl' : 'ltr'}; overflow: hidden; }
        .container-large { max-width: 1200px; margin: 0 auto; }
        
        .export-main-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; margin-bottom: 60px; }

        /* تجميل الكتابة */
        .export-header-meta { display: flex; align-items: center; gap: 20px; margin-bottom: 25px; }
        .export-badge { color: #d4af37; font-weight: 700; font-size: 0.85rem; letter-spacing: 1.5px; text-transform: uppercase; }
        .live-indicator { display: flex; align-items: center; gap: 8px; font-size: 0.8rem; color: #888; background: #f5f5f5; padding: 4px 12px; border-radius: 20px; }
        .dot { width: 7px; height: 7px; background: #27ae60; border-radius: 50%; animation: blink 1.5s infinite; }
        @keyframes blink { 0%, 100% { opacity: 1; } 50% { opacity: 0.3; } }

        .export-title { font-size: clamp(2.4rem, 4vw, 3.2rem); color: #0f2a43; font-weight: 800; line-height: 1.1; margin-bottom: 25px; }
        .export-desc { font-size: 1.15rem; color: #555; line-height: 1.8; margin-bottom: 40px; max-width: 520px; }
        
        .export-features-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 25px; }
        .f-item { display: flex; flex-direction: column; border-${isRtl ? 'right' : 'left'}: 4px solid #d4af37; padding: 10px 20px; background: #fafafa; border-radius: 4px; transition: 0.3s; }
        .f-item:hover { background: #f0f0f0; }
        .f-number { font-size: 2.2rem; font-weight: 800; color: #0f2a43; line-height: 1; }
        .f-label { font-size: 0.95rem; color: #777; margin-top: 8px; font-weight: 500; }

        /* المشهد (كما هو بدون تغيير في المنطق) */
        .visual-container { width: 100%; position: relative; }
        .visual-port-scene { position: relative; height: 480px; background: #050b16; border-radius: 35px; overflow: hidden; box-shadow: 0 40px 80px rgba(0,0,0,0.15); }
        .sky-bg { position: absolute; inset: 0; background: linear-gradient(to bottom, #02050a, #051020); }
        .moon { position: absolute; top: 40px; right: 50px; width: 45px; height: 45px; background: #fdfaf0; border-radius: 50%; box-shadow: 0 0 40px rgba(255,255,255,0.1); }
        .stars { position: absolute; inset: 0; background-image: radial-gradient(white, rgba(255,255,255,0.2) 1px, transparent 30px); background-size: 70px 70px; }
        .lighthouse { position: absolute; left: 40px; bottom: 130px; z-index: 30; width: 30px; }
        .lighthouse-body { height: 90px; background: #5a120d; clip-path: polygon(20% 0%, 80% 0%, 100% 100%, 0% 100%); }
        .light-beam { position: absolute; top: 0; left: 50%; width: 400px; height: 120px; background: radial-gradient(circle at left, rgba(212, 175, 55, 0.15), transparent 70%); clip-path: polygon(0 50%, 100% 0, 100% 100%); transform-origin: left center; animation: rotate-l 10s infinite linear; }
        @keyframes rotate-l { 0% { transform: rotateY(0deg); } 100% { transform: rotateY(360deg); } }

        .ship-path { position: absolute; ${isRtl ? 'right: -350px' : 'left: -350px'}; animation: sail linear infinite; }
        @keyframes sail { 0% { ${isRtl ? 'right: -350px' : 'left: -350px'}; } 100% { ${isRtl ? 'right: 125%' : 'left: 125%'}; } }
        .cargo-box-neon { width: 80px; height: 40px; background: #0a1525; display: flex; align-items: center; justify-content: center; color: #d4af37; font-weight: 800; font-size: 0.75rem; border: 1px solid #d4af37; box-shadow: 0 0 15px rgba(212, 175, 55, 0.2); }
        .vessel-body { width: 130px; height: 30px; background: #02050a; border-radius: 0 0 40px 40px; }
        .cabin-windows { width: 25px; height: 4px; background: #f1c40f; margin: 6px 15px 0 auto; box-shadow: 0 0 8px #f1c40f; border-radius: 1px; }
        .ocean-base { position: absolute; bottom: 0; width: 100%; height: 140px; z-index: 10; background: #02050a; }

        /* تنسيق الـ CTA السفلي */
        .cta-inner { background: #0f2a43; padding: 45px; border-radius: 30px; display: flex; justify-content: space-between; align-items: center; color: #fff; }
        .cta-text h3 { font-size: 1.7rem; margin-bottom: 8px; font-weight: 700; }
        .cta-text p { opacity: 0.7; font-size: 1rem; }
        .btn-export-contact { background: #d4af37; color: #0f2a43; padding: 16px 40px; border-radius: 50px; text-decoration: none; font-weight: 800; transition: 0.3s; border: 2px solid #d4af37; }
        .btn-export-contact:hover { background: transparent; color: #d4af37; }

        @media (max-width: 968px) {
          .export-main-grid { grid-template-columns: 1fr; gap: 50px; }
          .export-text-content { text-align: center; }
          .export-desc { margin: 0 auto 30px; }
          .export-header-meta { justify-content: center; }
          .cta-inner { flex-direction: column; text-align: center; gap: 30px; }
        }
      `}</style>
    </section>
  );
};

export default ExportSection;